type FiltersDataType = {
  name: string
  value: string
  title: string
}

export const filtersData: FiltersDataType[] = [
  {
    name: 'filter',
    value: 'hasAuth',
    title: 'Has auth',
  },
  {
    name: 'filter',
    value: 'hasData',
    title: 'Has data',
  },
]
